interface Config {
  isDevelopment: boolean;
  apiUrl: string;
  customerIdentificationServiceUrl: string;
  myPageLink: string;
  chatLink: string;
}

interface RemoteConfig {
  launchDarklyClientId: string;
}

const config: Config = {
  isDevelopment: import.meta.env.DEV,
  apiUrl: import.meta.env.VITE_API_API_URL || '/api',
  myPageLink: 'https://minside.rikstv.no/',
  chatLink: 'https://www.rikstv.no/chat/',
  customerIdentificationServiceUrl: 'https://integration-vipps.uat.rikstv.no/1',
};

export default config;

export const getConfig = async (): Promise<RemoteConfig> => {
  return new Promise((resolve) => {
    let launchDarklyClientId = '6708c59830431f083bb4a5bd'; // dev
    const hostname = location.hostname;
    switch (hostname) {
      case 'bestill.rikstv.no':
        launchDarklyClientId = '6708c551b923000862bf3d98';
        break;
      case 'bestill.uat.rikstv.no':
      case 'localhost':
        launchDarklyClientId = '6708c58254760f0874a43847';
        break;
    }
    resolve({ launchDarklyClientId });
  });
};
